import React from 'react';
// components
import Divider from "@mui/material/Divider";
import { Button, Card, CardHeader, CardContent, Tabs, Tab, Box, Typography } from '@mui/material';
import Swal from 'sweetalert2';

import Page from '../../componentes/Page';
import Iconify from '../../componentes/Iconify';
import CONFIG from '../../CONFIG.json';
import { buildBody, isEmpty, getUniqueKey, workWithLocalStorage, compruebaForm } from '../../auxiliares/funciones';
import { getProvincias, getAsesorias, getEmpresas, getTrabajadores, getConvenios,
    getOcupaciones, getCatalogoEsp, getCentrosFormacion, getComerciales, getFamProfesionales, getTutores } from '../../auxiliares/maestros';
import ContForm from './form/contform';
import AusenciasForm from './form/ausenciasform';
import EstadosForm from './form/estadosform';
import DocsForm from './form/docsform';
import EspForm from './form/especialidadesform';
import PlanForm from './form/planificacionform';
import BoniForm from './form/boniform';
import LiquiForm from './form/liquiform';



function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }
// ----------------------------------------------------------------------
export default function AltaForm(props) {
    const usuario = workWithLocalStorage('get','usuario',null);
    const Form = {
        idComercial:0,
        idAsesoria: 0,
        idEmpresa: 0,
        idTrabajador: 0,
        fechaInicio: '',
        fechaFin: '',
        duracion: 0,
        idFamiliaProfesional: 0,
        idOcupacion: 0,
        bonificacionTotal: 0,
        cantidadMinima: 0,
        idEspecialidad: 0,
        idConvenio: 0,
        tipoContrato: 0,
        horasLaborales: 0,
        hl1:0,hf1:0,hl2:0,hf2:0,
        horarioGeneral: '',
        horarioTrabajo: '',
        horarioFormacion: '',
        direccionTrabajo: '',
        idProvinciaTrabajo: 0,
        localidadTrabajo: '',
        nombreTutorLaboral:'',
        nifTutorLaboral:'',
        nombreTutorLaboral2:'',
        nifTutorLaboral2:'',
        observaciones: '',
        idCentroFormacion: 0,
        idTutor: 0,
        activo: 1,
      };
    const obligatorios = ['idComercial','idAsesoria','idEmpresa','idTrabajador','horasLaborales','idConvenio','fechaInicio','fechaFin','duracion','idOcupacion','idCentroFormacion','idProvinciaTrabajo'];

    const [contrato, setContrato] = React.useState(Form);
    const [cargado, setCargado] = React.useState(false);
    const [estadoCont, setEstadoCont] = React.useState('');
    const [comerciales, setComerciales] = React.useState([]);
    const [provincias, setProvincias] = React.useState([]);
    const [asesorias, setAsesorias] = React.useState([]);
    const [empresas, setEmpresas] = React.useState([]);
    const [convenios, setConvenios] = React.useState([]);
    const [tutores, setTutores] = React.useState([]);
    const [trabajadores, setTrabajadores] = React.useState([]);
    const [ocupaciones, setOcupaciones] = React.useState([]);
    const [famProfesionales, setFamProfesionales] = React.useState([]);
    const [catalogoEsp, setCatalogoEsp] = React.useState([]);
    const [centrosFormacion, setCentrosFormacion] = React.useState([]);
    const [id,setId] = React.useState(props.params.id ? props.params.id : '0');

    const [tabS, setTabS] = React.useState(0);

    const cambiaTabS = (event, newValue) => {
        setTabS(newValue);
    };

    React.useEffect(() => {
        async function cargaInicial(){
            if(!cargado){         
                setProvincias(await getProvincias());
                setComerciales(await getComerciales());
                setAsesorias(await getAsesorias());
                setEmpresas(await getEmpresas());
                setTrabajadores(await getTrabajadores());
                setOcupaciones(await getOcupaciones());
                setFamProfesionales(await getFamProfesionales());
                setCatalogoEsp(await getCatalogoEsp());
                setCentrosFormacion(await getCentrosFormacion());
                setConvenios(await getConvenios());
                const tut = await getTutores();
                tut.unshift({id:0,nombre:'No es necesario'});
                setTutores(tut);

                if(id !== '0'){                
                    // eslint-disable-next-line
                    const bodyJson = JSON.stringify(buildBody(CONFIG.TOKEN,{ id:id }))
                    fetch(`${CONFIG.api}contrato/detalle`,{
                                method: 'POST',
                                body: bodyJson,
                                headers: {'Content-Type': 'application/json'}
                        })
                        .then(res => res.json())
                        .then(async (result) => {
                        if (result.error === 0 && !isEmpty(result.data)) {
                            setContrato(result.data);
                            setEstadoCont(` - ${result.data.estadocontrato}`)
                            //  setAusencias(await getAusencias(result.data.id)); 
                        }
                        props.showLoader(false);
                        setCargado(true);
                    })
                }else{
                    // props.showLoader(false);  
                    setCargado(true);
                }
            }
        }
        cargaInicial();
      // eslint-disable-next-line
      },[cargado]);

    const Grabar = () =>{
        const valido = compruebaForm(Form,contrato,obligatorios);
        if(valido){
            // eslint-disable-next-line react/prop-types
            props.showLoader(true); 
            const body = contrato;
            body.idUsuarioAlta = usuario.id;
            body.idUsuarioMod = usuario.id;
            const bodyJson = JSON.stringify(buildBody(CONFIG.TOKEN,body))
            fetch(`${CONFIG.api}contrato/detalle`,{
                    method: 'PUT',
                    body: bodyJson,
                    headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then((result) => {
                let msg ='Contrato grabado!';
                if (result.error === 0) {   
                    setId(result.data.id);
                    document.getElementById(`simple-tab-${props.index}`).getElementsByTagName( 'span' )[0].textContent = `Editar Contrato #${result.data.id} `;
                    setCargado(false);
                }else{
                    props.showLoader(false); 
                    msg = result.errorMessage;
                }
                Swal.fire({
                title: msg,
                buttons: [{label: 'Ok'}]
                })
            })
        }else{
            Swal.fire({
                title: 'Revisa los campos con *',
                buttons: [{label: 'Ok'}]
            })
        }
    }

    const Nuevo = () =>{
        setContrato(Form);
        setId('0')
        document.getElementById(`simple-tab-${props.index}`).getElementsByTagName( 'span' )[0].textContent = 'Alta Contrato ';
    }
    
    const actualizaCampo = (input) =>{
        const nombre = input.target.name
        const valor = input.target.value
        const contratoA = contrato;
        contratoA[nombre] = valor
        setContrato(contratoA);
    }

    const Activar = () =>{
        // eslint-disable-next-line react/prop-types
        props.showLoader(true); 
        const body = {
          tabla: "contratos",
          activo: 1,
          usuario: usuario.id,
          id: contrato.id
        }
        const bodyJson = JSON.stringify(buildBody(CONFIG.TOKEN,body))
        fetch(`${CONFIG.api}master/activo`,{
                  method: 'PUT',
                  body: bodyJson,
                  headers: {'Content-Type': 'application/json'}
          })
          .then(res => res.json())
          .then((result) => {
            let msg ='Contrato activado!';
            if (result.error === 0) {   
                setCargado(false);
            }else{
              props.showLoader(false); 
              msg = result.errorMessage;
            }
            Swal.fire({
              title: msg,
              buttons: [{label: 'Ok'}]
            })
        })
    }

    const Borrar = () =>{
        // eslint-disable-next-line react/prop-types
        props.showLoader(true); 
        const body = {
            tabla: "contratos",
            activo: 0,
            usuario: usuario.id,
            id: contrato.id
        }
        const bodyJson = JSON.stringify(buildBody(CONFIG.TOKEN,body))
        fetch(`${CONFIG.api}master/activo`,{
                    method: 'PUT',
                    body: bodyJson,
                    headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then((result) => {
                let msg ='Contrato desactivado!';
                if (result.error === 0) {   
                    setCargado(false);
                }else{
                    props.showLoader(false); 
                    msg = result.errorMessage;
                }
                props.showLoader(false); 
                Swal.fire({
                title: msg,
                buttons: [{label: 'Ok'}]
                })
        })
    }
    
    return (
        <Page title="Alta Contrato" key={getUniqueKey()}>
            <Card  sx={{ maxWidth: '100% !important'}}>
                <CardHeader action={<>
                                    <Button variant="contained" color="success" sx={{ color: 'white', marginRight: '15px'}} to="#" startIcon={<Iconify icon="eva:plus-fill" />}
                                    onClick={()=>Grabar(null)}>
                                        Grabar
                                    </Button>
                                    <Button variant="contained" color="primary" sx={{ color: 'white', marginRight: '15px'}} to="#" startIcon={<Iconify icon="eva:edit-outline" />}
                                    onClick={()=>Nuevo()}>
                                        Nuevo
                                    </Button>
                                    {contrato.id &&
                                    (contrato.activo === 1 ?
                                    <Button variant="contained" color="error" sx={{ color: 'white'}} to="#" startIcon={<Iconify icon="eva:trash-2-outline" />}
                                    onClick={()=>Borrar()}>
                                        Borrar
                                    </Button>
                                    : <Button variant="contained" color="warning" sx={{ color: 'white'}} to="#" startIcon={<Iconify icon="eva:refresh-fill" />}
                                    onClick={()=>Activar()}>
                                        Activar
                                    </Button>)
                                    }
                                    </>}
                        title={id === '0' ? "Alta Contrato" : `Editar Contrato #${id}${estadoCont}`}
                />
                <Divider style={{ margin: '15px'}} />
                <Box sx={{bgcolor: 'background.paper',  margin: '15px'}}>
                    {contrato.id && 
                    <Tabs value={tabS} sx={{marginBottom: '15px', marginLeft: '25px', marginRight: '25px'}} onChange={cambiaTabS} variant="scrollable" scrollButtons="auto">
                        <Tab label="1. Datos del contrato" {...a11yProps(0)} className='tabsDivider'/>
                        <Tab label="2. Planificación" {...a11yProps(1)} className='tabsDivider'/>
                        <Tab label="3. Bonificaciones" {...a11yProps(2)} className='tabsDivider'/>
                        <Tab label="4. Liquidaciones" {...a11yProps(3)} className='tabsDivider'/>
                        <Tab label="5. Documentos" {...a11yProps(4)} className='tabsDivider'/>
                    </Tabs>
                    }
                    <TabPanel value={tabS} index={0}>
                        <CardContent>
                            {cargado &&
                            <ContForm showLoader={props.showLoader} contrato={contrato} comerciales={comerciales} provincias={provincias}
                                asesorias={asesorias} empresas={empresas} trabajadores={trabajadores} centrosformacion={centrosFormacion}
                                famProfesionales={famProfesionales} tutores={tutores} ocupaciones={ocupaciones} convenios={convenios} actualizaCampo={actualizaCampo}/>
                            }
                        </CardContent>
                        {contrato.id && <CardHeader title={'Ausencias'}/>}
                        {contrato.id && <Divider style={{ margin: '15px'}} />}
                        {contrato.id && 
                            <CardContent>
                                <AusenciasForm showLoader={props.showLoader} contrato={contrato} setCargadoC={setCargado}/>
                            </CardContent>
                        }
                        {contrato.id && <CardHeader title={'Estados'}/>}
                        {contrato.id && <Divider style={{ margin: '15px'}} />}
                        {contrato.id && 
                            <CardContent>
                                <EstadosForm showLoader={props.showLoader} contrato={contrato}/>
                            </CardContent>
                        }
                    </TabPanel>
                    {(contrato.id && cargado) && <TabPanel value={tabS} index={1}>
                        <CardContent>
                            <EspForm showLoader={props.showLoader} contrato={contrato} catalogo={catalogoEsp}/>
                            <CardHeader title={'Planificación'}/>
                            <Divider style={{ margin: '15px'}} />
                            <PlanForm showLoader={props.showLoader} contrato={contrato}/>
                        </CardContent>
                    </TabPanel>}
                    {(contrato.id && cargado) && <TabPanel value={tabS} index={2}>
                        <CardContent>
                            <BoniForm showLoader={props.showLoader} contrato={contrato}/>
                        </CardContent>
                    </TabPanel>}
                    {(contrato.id && cargado) && <TabPanel value={tabS} index={3}>
                        <CardContent>
                            <LiquiForm showLoader={props.showLoader} contrato={contrato}/>
                        </CardContent>
                    </TabPanel>}
                    {(contrato.id && cargado) && <TabPanel value={tabS} index={4}>
                        <CardContent>
                            <DocsForm showLoader={props.showLoader} contrato={contrato}/>
                        </CardContent>
                    </TabPanel>}
                </Box>
            </Card>
        </Page>
    );
}
